import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  CorrectionData: {},
};

const raisedCorrectionSlice = createSlice({
  name: "raisedCorrection",
  initialState,
  reducers: {
    raiseCorrectionRequest(state, action) {},
    raiseCorrectionRequestSuccess(state, action) {},
    raiseCorrectionRequestFailure(state, action) {},

    fetchCorrectionData(state, action) {
      state.CorrectionData = {};
    },
    fetchCorrectionDataSuccess(state, action) {
      state.CorrectionData = action.payload.data;
    },
    fetchCorrectionDataFailure(state, action) {
      state.CorrectionData = {};
    },
  },
});

export const { actions, reducer, name: sliceKey } = raisedCorrectionSlice;
